import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaCode, FaCloud, FaNetworkWired, FaDatabase, FaServer, FaExternalLinkAlt, FaGithub, FaCheckCircle } from 'react-icons/fa';

const allProjects = [
  {
    id: 'uwb-project',
    title: 'Ultra-Wideband (UWB) Wireless & Telemetry System',
    category: 'it',
    categoryName: 'IT Systems & IoT',
    image: '/uwb-og-use.jpg',
    fallbackBg: 'linear-gradient(135deg, #091d32 0%, #3498db 100%)',
    techStack: ['UWB', 'Wireless Communication', 'IoT', 'Embedded Systems', 'C/C++', 'Python'],
    description: 'Collaborative Ultra-Wideband (UWB) project engineered for high-precision real-time location tracking (RTLS), wireless sensor telemetry, and low-latency RF signal processing.',
    starImpact: 'Collaborative R&D implementation of ultra-wideband location positioning achieving high accuracy and robust wireless telemetry.',
    liveUrl: 'https://github.com/dejoo10/UWB',
    githubUrl: 'https://github.com/dejoo10/UWB'
  },
  {
    id: 'eastland-tutors',
    title: 'Eastland Top Tutors Platform',
    category: 'software',
    categoryName: 'Web & Full-Stack',
    image: '/adedeX95eastland.png',
    techStack: ['React.js', 'Node.js', 'Express', 'MongoDB', 'REST API'],
    description: 'Comprehensive full-stack educational platform connecting students with professional tutors. Features secure authentication, real-time booking scheduling, interactive course management, and responsive UI.',
    starImpact: 'Engineered end-to-end full-stack portal handling user auth, session management, and database queries with sub-second response times.',
    liveUrl: 'https://www.eastlandtoptutors.com/',
    githubUrl: 'https://github.com/dejoo10'
  },
  {
    id: 'cloud-terraform',
    title: 'Multi-Region AWS Infrastructure via Terraform',
    category: 'cloud',
    categoryName: 'Cloud & Infrastructure',
    image: '/cloud_engineering_arch.png', // User image suggestion
    fallbackBg: 'linear-gradient(135deg, #091d32 0%, #00d2d3 100%)',
    techStack: ['AWS VPC', 'Terraform (IaC)', 'EC2 AutoScaling', 'S3', 'IAM Roles'],
    description: 'Infrastructure as Code (IaC) repository automating multi-region AWS cloud deployments. Includes VPC peering, secure subnetting, auto-scaling groups, application load balancers, and encrypted S3 state backends.',
    starImpact: 'Reduced environment provisioning time from hours to under 4 minutes while implementing zero-trust IAM policies and cost-monitoring tags.',
    liveUrl: 'https://github.com/dejoo10',
    githubUrl: 'https://github.com/dejoo10'
  },
  {
    id: 'cisco-network-hardening',
    title: 'Enterprise Cisco Network Topology & Hardening',
    category: 'network',
    categoryName: 'Network Engineering',
    image: '/network_engineering_topology.png', // User image suggestion
    fallbackBg: 'linear-gradient(135deg, #091d32 0%, #2ecc71 100%)',
    techStack: ['Cisco CCNA', 'Packet Tracer', 'VLANs', 'OSPF', 'IPSec VPN', 'ACL Firewalls'],
    description: 'Comprehensive network architecture simulation detailing multi-branch enterprise setup. Implements VLAN segmentation, OSPF dynamic routing, site-to-site IPSec VPN tunnels, and strict access control lists (ACLs).',
    starImpact: 'Simulated high-availability enterprise network supporting 500+ endpoints with redundant gateways and automated failover.',
    liveUrl: 'https://github.com/dejoo10',
    githubUrl: 'https://github.com/dejoo10'
  },
  {
    id: 'cloud-cost-dashboard',
    title: 'Cloud Cost & Resource Analytics Dashboard',
    category: 'data',
    categoryName: 'Data Analytics',
    image: '/data_analysis_chart.png', // User image suggestion
    fallbackBg: 'linear-gradient(135deg, #091d32 0%, #f8d210 100%)',
    techStack: ['Python', 'SQL', 'Grafana', 'AWS Cost Explorer API', 'Pandas'],
    description: 'Real-time telemetry and financial data pipeline aggregating multi-cloud resource metrics. Visualizes CPU utilization, memory footprints, and monthly spending forecasts.',
    starImpact: 'Identified idle cloud resources and oversized EC2 instances, generating actionable cost optimization recommendations up to 25%.',
    liveUrl: 'https://github.com/dejoo10',
    githubUrl: 'https://github.com/dejoo10'
  },
  {
    id: 'smart-iot-monitor',
    title: 'Smart IoT Environmental Monitoring Network',
    category: 'it',
    categoryName: 'IT Systems & IoT',
    image: '/it_systems_iot.png', // User image suggestion
    fallbackBg: 'linear-gradient(135deg, #091d32 0%, #9b59b6 100%)',
    techStack: ['Raspberry Pi', 'Linux SysAdmin', 'Python', 'MQTT Protocol', 'Sensors'],
    description: 'Hardware and software integration project utilizing Raspberry Pi nodes to collect environmental sensor telemetry, transmitting data via MQTT to a central Linux aggregator.',
    starImpact: 'Deployed low-latency telemetry collection system operating continuously on Linux nodes with automated reboot recovery and alert triggers.',
    liveUrl: 'https://github.com/dejoo10',
    githubUrl: 'https://github.com/dejoo10'
  },
  {
    id: 'portfolio-v2',
    title: 'Adedeji Babalola Web App & Portfolio V2',
    category: 'software',
    categoryName: 'Web & Full-Stack',
    image: '/adedeX95personal.png',
    techStack: ['React 19', 'Styled Components', 'EmailJS', 'Glassmorphism UX', 'Vercel'],
    description: 'This very platform! Built with React 19 to present a dual-purpose showcase for HR recruiters and contract clients across Software, Cloud, Data, Networking, and IT roles.',
    starImpact: 'Implemented responsive design, interactive candidate matcher tools, ATS-friendly resume formatting, and direct client quote booking system.',
    liveUrl: 'https://adedejibabalola.com/',
    githubUrl: 'https://github.com/dejoo10'
  }
];

const ProjectsPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredProjects = activeCategory === 'all'
    ? allProjects
    : allProjects.filter(p => p.category === activeCategory);

  return (
    <div style={{ background: '#071325', minHeight: '100vh', color: '#ffffff', padding: '60px 24px' }}>
      <div style={{ maxWidth: '1150px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <span className="badge badge-gold" style={{ marginBottom: '12px' }}>
            🚀 Portfolio Showcase
          </span>
          <h1 style={{ fontSize: '2.5rem', color: '#ffffff', margin: '8px 0' }}>
            Featured Projects &amp; Repositories
          </h1>
          <p style={{ color: '#94a3b8', maxWidth: '680px', margin: '0 auto', fontSize: '1.05rem' }}>
            Explore technical projects demonstrating real-world software engineering, cloud automation, Cisco networking labs, data pipelines, and IT systems.
          </p>
        </div>

        {/* Category Filters */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '10px',
          marginBottom: '40px'
        }}>
          {[
            { id: 'all', label: 'All Projects', icon: <FaCheckCircle /> },
            { id: 'software', label: 'Web & Software', icon: <FaCode /> },
            { id: 'cloud', label: 'Cloud & IaC', icon: <FaCloud /> },
            { id: 'network', label: 'Networking (Cisco)', icon: <FaNetworkWired /> },
            { id: 'data', label: 'Data Analytics', icon: <FaDatabase /> },
            { id: 'it', label: 'IT Systems & IoT', icon: <FaServer /> },
          ].map(cat => {
            const isActive = activeCategory === cat.id;
            return (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '10px 20px',
                  borderRadius: '24px',
                  border: isActive ? '2px solid #45aaf2' : '1px solid rgba(255,255,255,0.15)',
                  background: isActive ? 'rgba(69, 170, 242, 0.25)' : 'rgba(16, 37, 66, 0.6)',
                  color: isActive ? '#ffffff' : '#94a3b8',
                  fontWeight: isActive ? '700' : '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
              >
                <span style={{ color: isActive ? '#45aaf2' : 'inherit' }}>{cat.icon}</span>
                <span>{cat.label}</span>
              </button>
            );
          })}
        </div>

        {/* Projects Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
          gap: '30px',
          marginBottom: '60px'
        }}>
          {filteredProjects.map(project => (
            <div key={project.id} className="glass-card" style={{
              display: 'flex',
              flexDirection: 'column',
              justify: 'space-between',
              overflow: 'hidden'
            }}>
              <div>
                {/* Project Image / Visual */}
                <div style={{
                  width: '100%',
                  height: '200px',
                  background: project.fallbackBg || '#102542',
                  position: 'relative',
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  justify: 'center'
                }}>
                  {project.image ? (
                    <img
                      src={project.image}
                      alt={project.title}
                      onError={(e) => {
                        // Fallback if user image isn't uploaded yet
                        e.target.style.display = 'none';
                      }}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  ) : null}
                  <span className="badge badge-gold" style={{
                    position: 'absolute',
                    top: '14px',
                    right: '14px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.5)'
                  }}>
                    {project.categoryName}
                  </span>
                </div>

                {/* Content */}
                <div style={{ padding: '24px' }}>
                  <h3 style={{ fontSize: '1.4rem', color: '#ffffff', margin: '0 0 10px 0', lineHeight: 1.3 }}>
                    {project.title}
                  </h3>

                  {/* Tech Stack Badges */}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '16px' }}>
                    {project.techStack.map((tech, i) => (
                      <span key={i} style={{
                        background: 'rgba(255,255,255,0.06)',
                        border: '1px solid rgba(255,255,255,0.12)',
                        color: '#45aaf2',
                        padding: '3px 10px',
                        borderRadius: '12px',
                        fontSize: '0.8rem',
                        fontWeight: '500'
                      }}>
                        {tech}
                      </span>
                    ))}
                  </div>

                  <p style={{ color: '#cbd5e1', fontSize: '0.95rem', lineHeight: '1.6', marginBottom: '16px' }}>
                    {project.description}
                  </p>

                  {/* STAR Business Impact */}
                  <div style={{
                    background: 'rgba(7, 19, 37, 0.7)',
                    borderLeft: '3px solid #45aaf2',
                    padding: '10px 14px',
                    borderRadius: '0 6px 6px 0',
                    color: '#94a3b8',
                    fontSize: '0.88rem',
                    marginBottom: '20px'
                  }}>
                    <strong style={{ color: '#ffffff' }}>Business Impact:</strong> {project.starImpact}
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div style={{
                padding: '16px 24px 24px 24px',
                display: 'flex',
                gap: '12px',
                borderTop: '1px solid rgba(255,255,255,0.08)'
              }}>
                <a
                  href={project.liveUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary"
                  style={{ padding: '8px 16px', fontSize: '0.88rem', flex: 1, justifyContent: 'center' }}
                >
                  View Project / Repo <FaExternalLinkAlt size={12} />
                </a>
                <a
                  href={project.githubUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-secondary"
                  style={{ padding: '8px 14px', fontSize: '0.88rem' }}
                  aria-label="GitHub Repository"
                >
                  <FaGithub size={16} />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Contract & Custom Project Callout */}
        <div className="glass-card" style={{
          padding: '36px',
          textAlign: 'center',
          background: 'linear-gradient(135deg, rgba(16, 37, 66, 0.9) 0%, rgba(7, 19, 37, 0.95) 100%)',
          borderColor: 'rgba(69, 170, 242, 0.4)'
        }}>
          <h3 style={{ fontSize: '1.8rem', color: '#ffffff', marginBottom: '12px' }}>
            Need a Custom Web App, Cloud Setup, or Network Hardening?
          </h3>
          <p style={{ color: '#94a3b8', fontSize: '1.05rem', maxWidth: '650px', margin: '0 auto 24px auto' }}>
            I am available for freelance contracts, custom software development, and technical consulting.
          </p>
          <Link to="/contact" className="btn-primary">
            Request Contract Quote &amp; Advisory
          </Link>
        </div>

      </div>
    </div>
  );
};

export default ProjectsPage;